// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2lYul","title":"ClientInsurance_title__3us0P","itemText":"ClientInsurance_itemText__2vQkU"};